import { render } from "./EstadoRecepcionList.vue?vue&type=template&id=627a6dc5&scoped=true"
import script from "./EstadoRecepcionList.vue?vue&type=script&lang=js"
export * from "./EstadoRecepcionList.vue?vue&type=script&lang=js"

import "./EstadoRecepcionList.vue?vue&type=style&index=0&id=627a6dc5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627a6dc5"]])

export default __exports__